import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from "@bookips/sds";
import { useRouter } from "next/router";
import { useMemo } from "react";
import { BreadCrumb } from "./BreadCrumb";
import { CategoryBanner } from "./CategoryBanner";
import { FreeTrialModule } from "./FreeTrialModule";
/** 헤더 스켈레톤 컴포넌트 */ const EditionCategoryHeaderSkeleton = (param)=>/*#__PURE__*/ {
    let { isFirstDepth  } = param;
    return _jsxs("section", {
        className: "flex w-full flex-col items-start gap-3 md:gap-4",
        children: [
            !isFirstDepth && /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center gap-1",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "h-4 w-16 animate-pulse rounded bg-gray-200"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "h-4 w-4 animate-pulse rounded bg-gray-100"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "h-4 w-20 animate-pulse rounded bg-gray-200"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "h-8 w-48 animate-pulse rounded bg-gray-200"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "w-full aspect-[4/1] md:aspect-[912/140] animate-pulse rounded-md bg-gray-200"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "w-full rounded-lg border border-gray-200 p-4 animate-pulse",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "flex flex-col gap-2",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "h-5 w-32 rounded bg-gray-200"
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "h-4 w-24 rounded bg-gray-100"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "h-10 w-28 rounded-md bg-gray-200"
                        })
                    ]
                })
            })
        ]
    });
};
export const EditionCategoryHeader = (param)=>{
    let { lnbTitle , lnbTitleHref , banners , categoryPath , getCategoryHref , categoryInfo , isLoading , isFirstDepth  } = param;
    const router = useRouter();
    // breadcrumb items 생성: lnbTitle + categoryPath
    const breadcrumbItems = useMemo(()=>[
            {
                label: lnbTitle,
                // categoryPath가 있으면 lnbTitleHref 사용 (LNB 타이틀과 같은 경로)
                ...categoryPath.length > 0 ? {
                    href: lnbTitleHref
                } : {}
            },
            ...categoryPath.map((item, index)=>{
                const isLast = index === categoryPath.length - 1;
                return {
                    label: item.title,
                    // 마지막 아이템은 href 없이 표시
                    ...isLast ? {} : {
                        href: getCategoryHref(item)
                    }
                };
            })
        ], [
        lnbTitle,
        lnbTitleHref,
        categoryPath,
        getCategoryHref
    ]);
    // 로딩 중이면 스켈레톤 표시
    if (isLoading) {
        return /*#__PURE__*/ _jsx(EditionCategoryHeaderSkeleton, {
            isFirstDepth: isFirstDepth
        });
    }
    // 현재 카테고리 제목 (categoryPath의 마지막 아이템 또는 lnbTitle)
    const currentTitle = categoryPath.length > 0 ? categoryPath[categoryPath.length - 1].title : lnbTitle;
    // 무료체험 모듈 표시 여부
    // - isEligible이 false이면 비노출
    // - 단, isEligible이 false여도 reason이 "not_logged_in"이면 노출
    const freeTrialPromotion = categoryInfo === null || categoryInfo === void 0 ? void 0 : categoryInfo.freeTrialPromotion;
    const showFreeTrial = (categoryInfo === null || categoryInfo === void 0 ? void 0 : categoryInfo.freeTrial) && freeTrialPromotion && (freeTrialPromotion.isEligible !== false || freeTrialPromotion.reason === "not_logged_in");
    // categoryPath가 비어있으면 1depth이므로 브레드크럼 숨김
    const shouldShowBreadcrumb = categoryPath.length > 0;
    var _freeTrialPromotion_remainingToday;
    return /*#__PURE__*/ _jsxs("section", {
        className: "flex w-full flex-col items-start gap-3 md:gap-4",
        children: [
            shouldShowBreadcrumb && /*#__PURE__*/ _jsx(BreadCrumb, {
                items: breadcrumbItems
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "h5",
                className: "text-strong sm:typo-h4 w-full break-words",
                children: currentTitle
            }),
            banners.length > 0 && /*#__PURE__*/ _jsx(CategoryBanner, {
                banners: banners
            }),
            showFreeTrial && freeTrialPromotion && /*#__PURE__*/ _jsx(FreeTrialModule, {
                remainingCount: (_freeTrialPromotion_remainingToday = freeTrialPromotion.remainingToday) !== null && _freeTrialPromotion_remainingToday !== void 0 ? _freeTrialPromotion_remainingToday : freeTrialPromotion.dailyLimit,
                totalCount: freeTrialPromotion.dailyLimit,
                endTime: freeTrialPromotion.expiredAt,
                purchaseUrl: categoryInfo === null || categoryInfo === void 0 ? void 0 : categoryInfo.purchaseUrl,
                promotionId: freeTrialPromotion.id,
                promotionTitle: freeTrialPromotion.title,
                onTimeUp: ()=>router.reload()
            })
        ]
    });
};
